const salesBalanceState = {
  salesBalanceSummary: null,
  loading: false,
};

export const salesBalanceSummaryReducer = (state = salesBalanceState, action) => {
  switch (action.type) {
    case "GET_SALES_BALANCE_SUMMARY":
      return {
        ...state,
        salesBalanceSummary: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const ballotingState = {
  ballotingReadiness: null,
  loading: false,
};

export const ballotingReadinessReducer = (state = ballotingState, action) => {
  switch (action.type) {
    case "GET_BALLOTING_READINESS":
      return {
        ...state,
        ballotingReadiness: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const installmentForecastState = {
  installmentForecast: null,
  loading: false,
};

export const installmentForecastReducer = (state = installmentForecastState, action) => {
  switch (action.type) {
    case "GET_INSTALLMENT_FORECAST":
      return {
        ...state,
        installmentForecast: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const contractStatusState = {
  contractStatus: null,
  loading: false,
};

export const contractStatusReducer = (state = contractStatusState, action) => {
  switch (action.type) {
    case "GET_CONTRACT_STATUS":
      return {
        ...state,
        contractStatus: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const rescheduleRiskState = {
  rescheduleRisk: null,
  loading: false,
};

export const rescheduleRiskReducer = (state = rescheduleRiskState, action) => {
  switch (action.type) {
    case "GET_RESCHEDULE_RISK":
      return {
        ...state,
        rescheduleRisk: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

